import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

const ChipStyled = styled(Chip)<{ selected?: boolean }>(
  ({ theme, selected }: any) => ({
    height: "auto",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    width: "max-content",
    color: selected
      ? theme.palette.common.corporateColors.primary.midNightBlue
      : theme.palette.common.corporateColors.primary.white,
    background: selected
      ? theme.palette.common.corporateColors.secondary.turquoise
      : theme.palette.common.corporateColors.primary.midNightBlue,
    border: `1px solid`,
    borderColor: `${
      selected
        ? theme.palette.common.corporateColors.secondary.turquoise
        : theme.palette.common.corporateColors.primary.white
    }`,
    padding: "3px 4px",
    ".MuiChip-label": {
      textTransform: "capitalize",
      display: "flex",
    },
    transition: "all 0.2s ease",
    ":hover": {
      color: theme.palette.common.corporateColors.primary.white,
      background:
        "linear-gradient(0deg,rgba(82, 212, 204, 0.20) 0%,rgba(82, 212, 204, 0.20) 100%), #031F32",
      borderColor:
        "linear-gradient(0deg,rgba(82, 212, 204, 0.20) 0%,rgba(82, 212, 204, 0.20) 100%), #031F32",
    },
  })
);

export const BlogCategoryChip = ({
  category,
  selected,
  onClick,
}: {
  category: string;
  selected: boolean;
  onClick?: () => void;
}) => {
  return (
    <ChipStyled
      onClick={onClick}
      size="small"
      label={<Typography variant="label-medium">{category}</Typography>}
      selected={selected}
    />
  );
};
